import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for addAdmin
 */

export interface addAdminBody {
	firstName: string
	lastName: string
	email: string
	mobile: string
	password: string
}

/**
 * Type Interface for the Response object you get from addAdmin request if successful
 */
export interface AddAdminsResponse {
	statusCode: number
	message: string
}

/**
 * API call create a new Admins
 * @param options AddAdminsParams - Options for the API call
 * @returns AdminResponse - Response object returned from the server
 */

export const addAdmin = async (body: addAdminBody) => {
	try {
		const { data } = await axios.post<AddAdminsResponse>(
			`management/new-user`,
			body
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default addAdmin
